export const environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyDSx258Y9_XOtYgjGNS9Qq9fl5MqKYF1D0'
};
